import { render } from "./vh-bar-chart.vue?vue&type=template&id=557b6bc7"
import script from "./vh-bar-chart.vue?vue&type=script&lang=js"
export * from "./vh-bar-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__